import { ChangeDetectionStrategy, Component, inject } from "@angular/core";

import {
  L2vpnSubscriptionDetailsGQL,
  L2vpnSubscriptionDetailsQuery,
} from "../../../../apis/networkdashboard/graphql/graphql";
import { SubscriptionPageComponent } from "../../../../components/subscription-detail/subscription-page/subscription-page";
import { L2vpnSubscriptionDetails } from "../../types";
import { GenericSubscription } from "../generic-subscription";
import { L2vpnSubscriptionView } from "./l2vpn-subscription-view";

@Component({
  selector: "l2vpn-subscription",
  templateUrl: "l2vpn-subscription.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [L2vpnSubscriptionView, SubscriptionPageComponent],
})
export class L2vpnSubscription extends GenericSubscription<L2vpnSubscriptionDetailsQuery, L2vpnSubscriptionDetails> {
  protected query = inject(L2vpnSubscriptionDetailsGQL);

  protected onQuerySuccess(data: L2vpnSubscriptionDetailsQuery): L2vpnSubscriptionDetails {
    return data.l2vpnDetails;
  }
}
